// @ts-ignore - this is actually generic but the typescript version we're using disagrees
export const isValidBase64File = (fileBuffer: Buffer<ArrayBuffer>, fileExtension: string) => {
  //should check  if theres bytes in the first place before doing anything else
  if (!fileBuffer || fileBuffer.length === 0) return false;

  //if it's one of these then the file buffer stuff is no use and the should just let AWS deal with it
  if (
    fileExtension === "csv" ||
    fileExtension === "text" ||
    fileExtension === "txt" ||
    fileExtension === "html" ||
    fileExtension === "htm"
  ) {
    return true;
  }

  // eic work differently from the magicBytes because you have to check the ftyp which are the 4-12 bytes
  if (fileExtension === "heic" || fileExtension === "heif") {
    return isHeic(fileBuffer);
  }

  // Make a little array to compare to our magic bytes - if the two arrays match the file is what it says it is
  const comparisonBytes = [toHex(fileBuffer[0]), toHex(fileBuffer[1])];
  const bytesToCompare = magicBytes[fileExtension];

  if (bytesToCompare === undefined) return false;

  const bytesComparisonMismatch = bytesToCompare.filter((element, index) => element !== comparisonBytes[index]);

  if (bytesComparisonMismatch.length) return false;

  return true;
};

const toHex = (num: number) => `0x` + num.toString(16);

const magicBytes: Record<string, string[]> = {
  png: ["0x89", "0x50"],
  jpeg: ["0xff", "0xd8"],
  jpg: ["0xff", "0xd8"],
  pdf: ["0x25", "0x50"],
  webp: ["0x52", "0x49"],
  doc: ["0xd0", "0xcf"],
  docx: ["0x50", "0x4b"],
  msg: ["0xd0", "0xcf"],
  eml: ["0x52", "0x65"],
  xlsx: ["0x50", "0x4b"],
  xls: ["0xd0", "0xcf"],
  xlsm: ["0x50", "0x4b"],
  ppt: ["0xd0", "0xcf"],
  pptx: ["0x50", "0x4b"],
  odt: ["0x50", "0x4b"],
};

const isHeic = (buffer: Buffer) => {
  if (buffer.length < 12) return false;

  // Check for "ftyp"
  const ftyp = buffer.toString("ascii", 4, 8);
  if (ftyp !== "ftyp") return false;

  //check for heic type
  const type = buffer.toString("ascii", 8, 12);

  const validTypes = ["heic", "heix", "hevc", "heif", "heim", "heis", "mif1"];

  return validTypes.includes(type);
};

export const readFileDataAsBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      resolve(event?.target?.result);
    };

    reader.onerror = (err) => {
      reject(err);
    };

    reader.readAsDataURL(file);
  });

export const fileTypeBytePattern = (file: File) => {
  const isImage = file.type.split("/")[0] === "image";
  return isImage ? /^data:(image)\/(\w)+;base64,/ : /^data:(application)\/([\w\D-])+;base64,/;
};
